export default {
  banners: [
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
    {
      imgUrl: require("../../assets/images/contact/contact-banner.jpg"),
      title: "",
      description: "",
      component: ""
    }
  ],
  contactUs: "contact us",
  a1: `D6-13 Floor, Tianfu Software Park, Chengdu(China)`,
  a2: `Bellevue, Washington, 98004, United States of America`,
  p1: `+86(028) 6593-5363 (China）`,
  p2: `+86 15928758550 (China）`,
  p3: `+86 400-871-8663 (China）`,
  p4: `+86 18349353270（China）`,
  p5: `+880 1825459736 (Bangladesh）`,
  p6: `+1 4258668398 (American）`,
  tips: `The most effective way to get in touch is to use the IM chat box in the lower right corner.`,
  map: require("../../assets/images/contact/map1.png"),
  info:
    "MaesInfo establishes lasting relationships with our clients to create value and accelerate their digital transformation journey.",
  address: [
    {
      title: "Chengdu,China",
      info: `Address:13F, Building D6, Tianfu Software Park,Tianfu Ave., <br/>
              Chengdu, Sichuan, P.R. China 610041<br/>
              Phone:+86 (28) 6593-5363<br/>
              Fax: +86(28) 8533-6315<br/>
              E-mail: sales@maesinfo.cn`
    },
    {
      title: "Shenzhen,China",
      info: ""
    },
    {
      title: "Changzhou,China",
      info: ""
    },
    {
      title: "Washington,USA",
      info: ""
    }
  ],
  qrCode: {
    qrImg: require("../../assets/images/contact/qrcode.png"),
    title: "iPhone  Android",
    description: "Get in touch with us through",
    url: "https://www.melinked.com"
  }
};
